import { useUserApi } from './useUserApi';
import { useUserGetters } from './useUserGetters';

import type { UseUser } from './types';
export function useUser(): UseUser {
  return {
    ...useUserApi(),
    ...useUserGetters(),
  };
}
